module.exports = require('./helpers/bundle-url').getBundleURL('eHJyV') + "images/content/" + require('./helpers/bundle-manifest').resolve("7f7Vv");